import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * Administrationen är alltid inloggad och behöver ingen serverrendering.
 * Vi renderar den på klienten så att tunga adminvyer aldrig kan fälla SSR.
 */
export const Route = createFileRoute("/_authenticated/admin")({
  ssr: false,
  component: AdminLayout,
});

function AdminLayout() {
  return <Outlet />;
}
